<template>
	<div class="user-watches-patients-grid">
		<div v-for="group in groups.data" :key="group.id" class="group" v-check-group="{ user_uid, group_id: group.id }">
			<div class="group-name">{{ group.name }}</div>
			<div class="group-container">
				<div class="idi-grid watches">
					<watch v-for="watch in group.elements" :key="watch.id" :user_uid="user_uid" :watch="watch" class="watch" :class="{ active: watch.online }"/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Watch from './UserWatchesPatientsGridWatch'
export default {
	props: [
		'user_uid',
		'groups'
	],
	components: {
		Watch
	},
	computed: {
		canRegistWatch () {
			return true
			return this.$store.getters.canRegistWatch
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/user/watches/UserWatchesPatientsGrid.vue